module.exports = __webpack_public_path__ + "static/media/icon-cooling.9e70cd14.svg";